<template>
  <div v-show="show" class="phone-watch-mask">
    <div class="phone-watch flex items-center flex-direction-column">
      <div class="watch-qr animated" :class="{ fadeIn: true }">
        <div
          style="font-size: 16px; color: #333; line-height: 3; padding: 10px"
        >
          直播间已加密
        </div>

        <el-form
          :model="formData"
          :rules="rules"
          ref="formRef"
          label-width="auto"
          class="demo-loginForm"
        >
          <el-form-item label="" prop="password" style="margin-bottom: 5px">
            <el-input
              v-model="formData.password"
              placeholder="请输入直播间密码"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="submit-btn" type="primary" @click="submitForm()"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PhoneWatch',

    props: {
      password: {
        // 密码
        type: String,
        require: true,
      },
    },

    data() {
      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入直播间密码'));
        } else {
          if (this.password !== '' && value !== this.password) {
            callback(new Error('密码错误，请重新输入'));
          }
          callback();
        }
      };
      return {
        show: true,
        formData: {
          password: '',
        },
        rules: {
          password: [
            { required: true, message: '请输入直播间密码', trigger: 'blur' },
            { validator: validatePass, trigger: 'blur' },
          ],
        },
      };
    },

    mounted() {
      const isPasswordValid = sessionStorage.getItem('isPasswordValid');
      if (isPasswordValid === 'true') {
        console.log('用户已通过密码验证');
        // 允许用户访问页面
        this.close();
      }
    },

    methods: {
      submitForm: _.throttle(
        function () {
          this.$refs.formRef.validate((valid) => {
            console.log('valid :>> ', valid);
            if (!valid) return;
            console.log('请求接口');
            sessionStorage.setItem('isPasswordValid', 'true');
            this.close();
          });
        },
        2000,
        { trailing: false },
      ),

      open() {
        this.show = true;
      },
      close() {
        this.show = false;
      },
    },
  };
</script>

<style lang="less" scoped>
  .phone-watch-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
  .phone-watch {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .watch-qr {
    display: block;
    transform: all 0.3s;
    padding: 10px;
    width: 300px;
    height: 200px;
    padding: 0 20px;
    background: #fff;
    border-radius: 5px;
  }

  .submit-btn {
    margin-top: 20px;
  }
</style>
